var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1674 31.8283C75.6982 13.8384 59.0461 0 40.3126 0C22.9667 0 7.7023 11.0707 2.15161 26.9849C-3.39908 42.8991 2.15161 60.889 14.6407 71.2678C27.8235 81.6466 46.5571 83.0304 61.1276 74.0355C75.0043 65.0405 82.6365 48.4344 79.1674 31.8283ZM63.2091 66.4244C52.1078 76.1113 36.1496 77.4951 22.9667 70.5759C10.4776 62.9648 2.84545 48.4344 5.62079 33.9041C8.39613 17.298 22.9667 5.53536 40.3126 4.84344C54.8831 4.84344 68.066 13.8384 72.9228 27.6768C77.7797 41.5152 73.6167 56.7375 63.2091 66.4244Z",
    fill: "#BB4048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.31 19.3735C43.0853 19.3735 45.1668 21.4493 44.473 24.217L41.6976 49.818C41.6976 50.5099 41.0038 51.2019 40.31 51.2019C39.6161 51.2019 38.9223 50.5099 38.9223 49.818L35.4531 24.217C35.4531 21.4493 37.5346 19.3735 40.31 19.3735Z",
    fill: "#BB4048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.31 60.1975C41.8428 60.1975 43.0854 58.9581 43.0854 57.4293C43.0854 55.9005 41.8428 54.6611 40.31 54.6611C38.7772 54.6611 37.5347 55.9005 37.5347 57.4293C37.5347 58.9581 38.7772 60.1975 40.31 60.1975Z",
    fill: "#BB4048"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.577f7a8d50968c298913cd8a32acaea2.svg";
export { ForwardRef as ReactComponent };